import { useAuth0 } from "@auth0/auth0-react";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import PollIcon from "@material-ui/icons/Poll";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React from "react";

import { ReactComponent as XlsxIcon } from './xlsx.svg';
import MUITooltip from "@material-ui/core/Tooltip";
import MonthSelect from "./MonthSelection";
import CostByStagesTable from "./CostByStagesTable";
import LibraryIcon from '@material-ui/icons/LocalLibraryOutlined';
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import { Popover } from "@material-ui/core";

import { apiurl } from '../app/prefs.js';


export default function Report037() {
  const [totalData, setTotalData] = React.useState([]);
  const [totalDataLoaded, setTotalDataLoaded] = React.useState(false);
  const [totalDataComplete, setTotalDataComplete] = React.useState(false);
  const [filtersLoaded, setFiltersLoaded] = React.useState(false);
  const [dateList, setDateList] = React.useState([]);
  const [startDate, setStartDate] = React.useState(null);
  const { getAccessTokenSilently, user } = useAuth0();
  const [selectedMonths, setSelectedMonths] = React.useState([]);
  const [reportInfoOpen, setReportInfoOpen] = React.useState(false);


  function DateBox(props) {
    return (
      <Autocomplete
        id="combo-box"
        options={dateList}
        value={startDate}
        size="small"
        disableClearable
        autoHighlight
        getOptionLabel={(option) => option && option.year.toLocaleString()}
        defaultValue={null}
        getOptionSelected={(option, value) => {
          if (!value) return false;
          return option.year.toLocaleString() === value.year.toLocaleString();
        }}
        style={{ width: "80px", marginBottom: "10px", marginLeft: '10px', marginRight: '10px' }}
        renderInput={(params) => <TextField {...params} label="Rok" />}
        onChange={(event, value) => {
          if (value) {
            setStartDate(value);
            loadData(value.year, selectedMonths);
          }
        }}
      />
    );
  }


  function loadDataBasic(year, months) {
    loadData(year, months)
  }

  const loadData = (year, months) => {
    setTotalDataLoaded(false);
    setTotalDataComplete(false);
    const apiUrl = `${apiurl}/getinfrastructurecost/${year}/${JSON.stringify(months)}/json`;
    getAccessTokenSilently().then((token) => {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      };
      fetch(apiUrl, requestOptions)
        .then((res) => res.json())
        .then((fetchedData) => {
          setTotalData(fetchedData);
          if (
            fetchedData.length !== 0
          ) setTotalDataComplete(true);
          setTotalDataLoaded(true);
        });
    });
  }

  const loadFilters = () => {
    setFiltersLoaded(false);
    const apiUrl = `${apiurl}/salariesreport`;
    getAccessTokenSilently().then((token) => {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      };
      fetch(apiUrl, requestOptions)
        .then((res) => res.json())
        .then((fetchedData) => {
          setDateList(fetchedData.YEARS);
          if (fetchedData.YEARS && fetchedData.YEARS.length !== 0) {
            setStartDate(fetchedData.YEARS[fetchedData.YEARS.length - 1]);

            loadData(fetchedData.YEARS[fetchedData.YEARS.length - 1].year, selectedMonths);
            setFiltersLoaded(true);
          }
        });
    });
  }

  const downloadFile = (downloadURL) => {

    getAccessTokenSilently().then((token) => {
      document.body.style.cursor = 'wait';
      const apiUrl = downloadURL
      fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          Authorization: "Bearer " + token,
        },
      })
        .then((response) => response.blob())
        .then((blob) => {
          // Create blob link to download
          const url = window.URL.createObjectURL(
            new Blob([blob]),
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            `Przychody i koszty.xlsx`,
          );
          // Append to html link element page
          document.body.appendChild(link);
          // Start download
          link.click();
          // Clean up and remove the link
          link.parentNode.removeChild(link);
          document.body.style.cursor = 'auto';
        });
    });

  };

  React.useEffect(() => {
    let mounted = true;
    //console.log("Main mounted");
    if (mounted) loadFilters();
    return function cleanup() {
      //console.log("Main unmounted");
      mounted = false;
    };
  }, []);

  return (
    <div className="App" style={{ position: "relative" }}>
      <div
        style={{
          background: "linear-gradient(to right, #0b6471, #0b6471)",
          display: "flex",
          height: "45px",
          width: "100%",
          backgroundColor: "#0b6471",
          color: "white",
          borderRadius: "5px",
          paddingTop: "0px",
          paddingLeft: "0px",
          alignItems: "center",
        }}
      >
        <div style={{ width: "80px", marginTop: "5px" }}>
          <PollIcon
            style={{
              marginLeft: "20px",
              marginRight: "20px",
              fontSize: "42px",
            }}
          />
        </div>
        <div>
          <Typography variant="h5" style={{ color: "white" }}>
            Koszt infrastruktury
          </Typography>
        </div>
      </div>
      <p style={{ height: "5px" }} />
      {filtersLoaded ? (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            position: "relative",
            width: "100%",
          }}
        >
          <DateBox data={dateList} />
          <div style={{ marginRight: '5px' }}>
            <MonthSelect
              setSelectedMonthsFunction={setSelectedMonths}
              loadDataFunction={loadDataBasic}
              selectedMonthsProperty={selectedMonths}
              startDateProperty={startDate}
            />
          </div>
          <MUITooltip title='Opis raportu'>
            <LibraryIcon
              id='reportInfoIcon'
              onClick={() => setReportInfoOpen(true)}
              style={{ marginTop: '15px', marginRight: '5px', cursor: 'pointer', width: '22px', height: '22px', fill: '#0b6471' }}
            />
          </MUITooltip>

          {false && <MUITooltip title='Pobierz raport jako plik MS Excel'>
            <XlsxIcon
              style={{ marginTop: '15px', cursor: 'pointer', width: '22px', height: '22px', fill: '#0b6471' }}
              onClick={
                () => downloadFile(`${apiurl}/getinfrastructurecost/${startDate.year}/${JSON.stringify(selectedMonths)}/xlsx`)
              }
            />
          </MUITooltip>}
        </div>
      ) : (
        <div>Wczytywanie danych</div>
      )}
      <p style={{ height: "5px" }} />

      {totalDataComplete ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            overflow: "auto",
            transition: "opacity 0.5s",
            opacity: totalDataLoaded ? "1" : "0.2",
          }}
        >
          <div
            id="top chart area"
            style={{
              display: "flex",
              flexWrap: "wrap",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <div
              id="left chart area"
              style={{
                display: "flex",
                flexWrap: "wrap",
                //maxWidth: "840px",
                width: "100%",
                flexDirection: "column",
                flexShrink: 1,
              }}
            >

              <div
                id="top 3 bottom 3 tables area"
                style={{
                  display: "flex",
                  paddingRight: "0px",
                  alignItems: "stretch",
                  flexWrap: "wrap",
                  width: "100%",
                  flexDirection: "row",
                  flexGrow: 1,
                  flexShrink: 1,
                }}
              >

                <CostByStagesTable
                  title=' '
                  dimUnexpanded='true'
                  data={totalData}
                  columns={
                    [
                      { name: 'Indeks OPK', value: 'id', align: 'left', type: 'text', underline: '1px solid' },
                      { name: 'Nazwa OPK', value: 'name', align: 'left', type: 'text', underline: '1px solid' },
                      { name: <div style={{ fontWeight: "100" }}>Koszt infrastruktury</div>, value: 'cost', chartValue: 'costMonthly', align: 'right', type: 'mixed', underline: '2px solid' },
                      { name: <div style={{ fontWeight: "100" }}>Liczba godzin pracy</div>, value: 'hoursWorked', chartValue: 'hoursWorkedMonthly', align: 'right', type: 'mixed', underline: '2px solid' },
                      { name: <div style={{ fontWeight: "100" }}>Średni koszt godziny infrastruktury</div>, value: 'costPerHour', chartValue: 'costPerHourMonthly', align: 'right', type: 'mixed', underline: '2px solid' },
                    ]
                  }
                />

              </div>
            </div>
          </div>
        </div>
      ) : (
        !totalData.data_by_opk && (
          <Typography
            style={{
              position: "absolute",
              top: "120%",
              left: "40%",
              color: "#0b6471",
              textJustify: "left"
            }}
            variant="h5"
          >
            Wczytywanie danych
          </Typography>
        )
      )}
      {!totalDataLoaded && (
        <CircularProgress
          style={{
            position: "absolute",
            height: "70px",
            width: "70px",
            top: totalData[0] ? "50%" : "120%",
            left: "50%",
            color: "#0b6471",
            opacity: "0.6",
          }}
        />
      )}
      <Popover
        id='hintPopOver'
        open={reportInfoOpen}
        anchorEl={document.getElementById('reportInfoIcon')}
        onClose={() => setReportInfoOpen(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
      >
        <Paper
          style={{
            padding: "10px",
            width: "600px",
            fontFamily: "roboto",
            display: "flex",
            flexDirection: "column"
          }}
        >
          <div
            style={{
              top: "0px",
              display: "flex",
              width: "100%",
              justifyContent: "right"
            }}
          >
            <CloseIcon style={{ cursor: 'pointer', fontSize: '16px' }} onClick={() => setReportInfoOpen(false)} />
          </div>
          <div style={{ fontSize: '16px', padding: '5px', marginBottom: '5px' }}>

            <p>
              <b>
                Jak liczony jest koszt infrastruktury procedur zabiegowych do wniosków indywidualnych z NFZ, na bazie danych z SRK?
              </b>
            </p>
            <br />
            <p>
              Koszt infrastruktury OPK proceduralnego (507) uwzględnia:
            </p>
            <ol>
              <li>
                Koszty bezpośrednie z kont <b>400, 403, 406 (wszystkie konta)</b>
              </li>
              <li>Koszty bezpośrednie z kont <b>401, z pominięciem:</b>
                <ol type="a">
                  <li>
                    kont z grup:
                    <ol type="i">
                      <li>
                        401-02-01-XX - Leki (za wyjątkiem programów lekowych oraz leków do chemioterapii)
                      </li>
                      <li>
                        401-02-02-XX - Leki do programów lekowych, leki do chemioterapii
                      </li>
                      <li>
                        401-02-03-XX - Inne leki
                      </li>

                    </ol>
                  </li>
                  <li>
                    konkretnych kont:
                    <ol type="i">
                      <li>
                        401-02-04-02 - Jednorazowe staplery i zszywki
                      </li>
                      <li>
                        401-02-04-03 - Igły, strzykawki, wenflony
                      </li>
                      <li>
                        401-02-04-04 - Materiały szewne, w szczególności nici chirurgiczne
                      </li>
                      <li>
                        401-02-04-05 - Obłożenia i podkłady jednorazowe, w szczególności zestawy
                      </li>
                      <li>
                        401-02-04-08 - Rękawice jednorazowe
                      </li>
                      <li>
                        401-02-04-09 - Środki opatrunkowe
                      </li>
                      <li>
                        401-02-04-10 - Niewszczepialny jednorazowy sprzęt i niewszczepialne wyroby medyczne
                      </li>
                      <li>
                        401-02-04-11 - Wszczepialne wyroby medyczne
                      </li>
                      <li>
                        401-02-04-16 - Pozostały jednorazowy sprzęt i materiały medyczne
                      </li>

                    </ol>
                  </li>
                </ol>

              </li>
              <li>
                Koszty wynagrodzeń i podwykonawstwa medycznego (<b>wybrane konta 402, 404, 405</b>) następujących grup pracowniczych:
                psycholodzy, psychoterapeuci, terapeuci uzależnień; dietetycy; logopedzi; terapeuci zajęciowi; pozostały
                personel niemedyczny (salowe, rejestratorki, sekretarki medyczne, opiekunowie medyczni,
                sanitariusze itd.); pozostały personel niemedyczny, administracyjny, zarząd.
                <b>Koszty wynagrodzeń i podwykonawstwa medycznego pozostałych grup
                nie są uwzględnione w koszcie infrastruktury.</b>
              </li>
              <li>
                Koszty doliczone do OPK 507  - <b>koszty pośrednie z OPK 507, 530 i 535</b>.
              </li>
            </ol>

          </div>
          <div
            style={{
              top: "60px",
              display: "flex",
              justifyContent: "flex-end",
              borderTop: '1px #0B6471 solid'
            }}
          >
            <Button onClick={() => setReportInfoOpen(false)}>
              Zakończ
            </Button>
          </div>
        </Paper>
      </Popover>
    </div>
  );
}
